import { methods, MethodOption } from '../../domain'

export function useMethods(): Record<string, MethodOption[]> {
  return {
    methods,
  }
}
